import { ComponentType, lazy } from "react";
export const RolePermissions = lazy(() => import("@/B2C/features/rolePermission/RolePermissions"));
export const Dashboard = lazy(() => import("@/B2C/features/dashboard/dashboardIndex"));
export const Clients = lazy(() => import("@/B2C/features/clients/ClientPage"));
export const Quotes = lazy(() => import("@/B2C/features/quotes/QuotesPage"));
export const PipeLine = lazy(() => import("@/B2C/features/Pipeline/PipelinePage"));
export const PoliciesPage = lazy(() => import("@/B2C/features/Policies/PoliciesPage"));
export const CommissionLedgerPage = lazy(
  () => import("@/B2C/features/CommissionLedger/CommissionLedgerPage")
);
export const InvoicesPage = lazy(() => import("@/B2C/features/Invoices/InvoicesPage"));
export const SettingsPage = lazy(() => import("@/B2C/features/setting/settingPage"));
export const LovableHub = lazy(() => import("@/B2C/features/lovable/LovableHubPage"));
export const Insurer = lazy(() => import("@/ADMIN/feature/insurar/InsurarPage"));
export const ApiConfiguration = lazy(() => import("@/ADMIN/feature/apiConfig/ApiConFigPage"));
export const ThirdPartyApi = lazy(() => import("@/ADMIN/feature/thirdPartyApi/ThirdPartyApiPage"));
export const Logs = lazy(() => import("@/ADMIN/feature/Logs-monitoring/LogPage"));
export const Channels = lazy(() => import("@/ADMIN/feature/Channels/ChannelsPage"));
export const ReviewQueuePage = lazy(() => import("@/ADMIN/feature/ReviewQueue/ReviewQueuePage"));
export const MasterManagementPage = lazy(
  () => import("@/B2C/features/masterManagement/MasterManagementPage")
);
export const ViewPolicyPage = lazy(
  () => import("@/D2C/features/retail-dashboard/components/policies/ViewPolicyPage")
);
export const ServiceTemplatePage = lazy(
  () => import("@/ADMIN/feature/apiConfig/components/ServiceTemplatePage")
);
export const LogDetailsPage = lazy(() => import("@/ADMIN/feature/Logs-monitoring/LogDetailsPage"));
export const ClientFetchQuote = lazy(() => import("@/B2C/features/clients/ClientFetchQuote"));

export type ModuleDetailRouteTemplate = {
  suffix: string;
  element: ComponentType<any>;
};
// Lazy-loaded component imports for secure elements.
export const SECURE_ELEMENT_REGISTRY: Record<string, ComponentType<any>> = {
  Dashboard,
  Clients,
  Quotes,
  PipeLine,
  PoliciesPage,
  CommissionLedgerPage,
  InvoicesPage,
  Settings: SettingsPage,
  LovableHub,
  Insurer,
  ApiConfiguration,
  RolePermissions,
  ThirdPartyApi,
  Logs,
  Channels,
  ReviewQueuePage,
  MasterManagementPage,
  CommissionDashboard: LovableHub,
  IRDAICompliancePage: LovableHub,
  Reconciliation: LovableHub,
  Variances: LovableHub,
  Tds: LovableHub,
  Reports: LovableHub,
  Configuration: LovableHub,
  Cases: LovableHub,
  Claims: LovableHub,
};

//  MEntion here nested routes
export const MODULE_DETAIL_ROUTE_TEMPLATES: Record<string, ModuleDetailRouteTemplate[]> = {
  PoliciesPage: [{ suffix: ":id/policy-details", element: ViewPolicyPage }],
  ApiConfiguration: [{ suffix: ":id/:insurer_id", element: ServiceTemplatePage }],
  Logs: [{ suffix: ":log_id", element: LogDetailsPage }],
  Quotes: [{ suffix: ":quoteId/edit", element: ClientFetchQuote }],
};

// Fallback elements for module names that don't have a direct component mapping.
export const MODULE_NAME_ELEMENT_FALLBACK: Record<string, ComponentType<any>> = {
  "commission-dashboard": LovableHub,
  "irdai-compliance": LovableHub,
  reconciliation: LovableHub,
  variances: LovableHub,
  tds: LovableHub,
  reports: LovableHub,
  configuration: LovableHub,
  case: LovableHub,
  claims: LovableHub,
};
